'use client';

import { c as _c } from "react/compiler-runtime";
import { LazyMotion } from 'framer-motion';

// ----------------------------------------------------------------------

const loadFeaturesAsync = async () => import('./features').then(res => res.default);
export function MotionLazy(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <LazyMotion strict={true} features={loadFeaturesAsync}>{children}</LazyMotion>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}